import {createAction, props} from "@ngrx/store";
import {Provider} from "../../model/providers";
import {PROVIDERS_TO_DISPLAY_LOADED} from "./provider.actions";
import {MapPolygon} from "../../model/summary";

export const POLYGON_SELECTED = '[Polygons API] Polygon Selected';
export const POLYGON_MODIFIED = '[Polygons API] Polygon modified';
export const LOAD_POLYGONS = '[Polygons API] Load Polygons';
export const UPDATE_POLYGON_SUM = '[Polygons API] Update Polygon Sum';
export const BK_POLYGON_DATA = '[Polygons API] BK Polygon Data';
export const NUKE_BK_POLYGON_DATA = '[Polygons API] Nuke BK Polygon Data';

export const polygonSelected = createAction(
  POLYGON_SELECTED,
  props<{ polygon: MapPolygon }>()
);

export const polygonModified = createAction(
  POLYGON_MODIFIED,
  props<{ polygon: MapPolygon }>()
);

export const updatePolygonSum = createAction(
  UPDATE_POLYGON_SUM
);

export const loadPolygons = createAction(
  LOAD_POLYGONS,
  props<{ polygons: any }>()
);

export const bkPolygonData = createAction(
  BK_POLYGON_DATA,
  props<{ polygonsFC: any }>()
);

export const nukeBkPolygonData = createAction(
  NUKE_BK_POLYGON_DATA
);
